import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { UserProductGroup } from '~/Api/User/ProductGroup';
import { Module, selectReferenceBasketVersions, State as PriceReferencingState } from '~/PriceReferencing';
import { State as RoMaxPriceState, Update } from '~/RoMaxPrice/reducer';
import { Status } from '~/UI/SaveActivityIndicator/SaveActivityIndicator';

import ParametersPanel from './ParametersPanel';

import type { ReferenceBasketVersion } from '~/Api/RoPriceReferencing/MaxPrice';

interface State {
	roMaxPrice: RoMaxPriceState;
	priceReferencing: PriceReferencingState;
}

interface OwnProps {
	group: UserProductGroup;
}

const selectUpdateStatus = memoizeOne((groupId: string, update: Update | null) => {
	if (update?.groupId !== groupId) {
		return null;
	}

	switch (update.state.name) {
		case 'scheduled':
		case 'fetching':
			return Status.saving;
		case 'updated':
			return Status.saved;
		case 'failed':
			return Status.failed;
		default:
			return null;
	}
});

const mapStateToProps = ({ roMaxPrice, priceReferencing }: State, { group }: OwnProps) => ({
	updateStatus: selectUpdateStatus(group.id, roMaxPrice.update),
	versions: selectReferenceBasketVersions(priceReferencing, Module.roMaxPrice),
	productTypes: roMaxPrice.productTypes?.types ?? null,
});

export default connect(mapStateToProps)(ParametersPanel);
